/**
 * A global namespace for `Delete` key.
 * e.which = 46 equivalent
 */
const keyDelete = 'Delete';

export default keyDelete;
